import {createSlice} from "@reduxjs/toolkit";
import {fetchSupportPlugins} from "./supportPluginsThunks";

export const supportPluginsSlice = createSlice({
    name: 'supportPlugins',
    initialState: {
        supportPlugins: [],
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSupportPlugins.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSupportPlugins.fulfilled, (state, action) => {
                state.loading = false;
                state.supportPlugins = action.payload;
            })
            .addCase(fetchSupportPlugins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
})
export default supportPluginsSlice.reducer;